export const GalleryData = [
  {
    id: 1,
    width: 600,

    tag: "Transportation",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Nature",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m2.jpg",
  },
  {
    id: 2,
    width: 400,

    tag: "Colorful Objects",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Nature",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m3.jpg",
  },
  {
    id: 3,
    width: 1000,

    tag: "Clever & Creative",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Nature",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m5.jpg",
  },
  {
    id: 4,
    width: 600,

    tag: "Old Suitcases",
    data: "Curabitur blandit tempus porttitor.",
    titile: "Nature",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m9.jpg",
  },
  {
    id: 5,
    width: 200,

    tag: "Pretty Tulips",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Nature",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m6.jpg",
  },
  {
    id: 6,
    width: 600,

    tag: "Happy Workshop",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Nature",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m8.jpg",
  },
  {
    id: 7,
    width: 600,

    tag: "Coffee Time",
    data: "Maecenas sed diam eget risus varius blandit.",
    titile: "Conceptual",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m1.jpg",
  },
  {
    id: 8,
    width: 800,

    tag: "Transportation",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Conceptual",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m5.jpg",
  },
  {
    id: 9,
    width: 800,

    tag: "Colorful Objects",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Conceptual",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m7.jpg",
  },
  {
    id: 10,
    tag: "Clever & Creative",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Food & Drink",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m4.jpg",
  },
  {
    id: 11,
    tag: "Transportation",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Portrait",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m2.jpg",
  },
  {
    id: 12,
    width: 900,

    tag: "Clever & Creative",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Portrait",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m6.jpg",
  },
  {
    id: 13,
    width: 800,

    tag: "Old Suitcases",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Portrait",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m9.jpg",
  },
  {
    id: 14,
    width: 600,

    tag: "Colorful Objects",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Motion",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m8.jpg",
  },
  {
    id: 15,
    width: 600,

    tag: "Clever & Creative",
    data: "Aenean lacinia bibendum nulla sed consectetur.",
    titile: "Motion",
    image: "https://demos.elemisthemes.com/juno8/style/images/art/m3.jpg",
  },
];
